import { useNavigate } from "react-router"

// Empty-state shown when the wizard mounts without a selected team.
// The team-switcher lives in AppLayout, but the wizard pages render
// without that chrome — so we route the user to /dashboard, where the
// switcher is reachable. Each flow passes its own copy + emoji.

interface NoTeamPickedProps {
  emoji: string
  title: string
  body: string
  ctaLabel: string
}

export function NoTeamPicked({ emoji, title, body, ctaLabel }: NoTeamPickedProps) {
  const navigate = useNavigate()
  return (
    <div className="min-h-[calc(100vh-4rem)] bg-gradient-to-b from-zinc-50 to-white flex items-center justify-center px-6">
      <div className="max-w-md text-center space-y-5 py-10">
        <div className="mx-auto size-14 rounded-full bg-zinc-100 grid place-items-center">
          <span className="text-[24px]">{emoji}</span>
        </div>
        <div className="space-y-2">
          <h2 className="text-[22px] font-bold text-zinc-900 tracking-tight">
            {title}
          </h2>
          <p className="text-[14px] text-zinc-500 leading-relaxed">
            {body}
          </p>
        </div>
        <button
          type="button"
          onClick={() => navigate("/dashboard")}
          className="inline-flex items-center gap-1.5 h-11 px-4 rounded-xl bg-zinc-900 hover:bg-black text-white text-[13.5px] font-semibold shadow-md transition-colors duration-150"
        >
          {ctaLabel}
        </button>
      </div>
    </div>
  )
}
